import { render, staticRenderFns } from "./FormW9Person.vue?vue&type=template&id=a17f3c12&"
import script from "./FormW9Person.vue?vue&type=script&lang=ts&"
export * from "./FormW9Person.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports